<template>
  <div id="trip-info">
    <div class="trip-summary">
      <label>Trip Start</label>
      <input type="datetime-local" :value="tripStart" disabled />
      <label>Start Location</label>
      <input type="text" :value="tripStartLocation" disabled />
      <label>End Location</label>
      <input type="text" :value="tripEndLocation" disabled />
      <Vehicle />
    </div>

    <Route v-for="route in routes" :key="route.summary" :route="route" />

  </div>
</template>

<script>
import moment from 'moment';

import Vehicle from './Vehicle.vue';
import Route from './Route.vue';

export default {
  components: { Route, Vehicle },
  mounted() {
    console.log(this.$store.state.trip);
    console.log(this.$store.state.model);
  },
  computed: {
    tripStart() {
      return moment.unix(this.$store.state.trip.startTime).format('YYYY-MM-DDTHH:mm');
    },
    tripStartLocation() {
      return this.$store.state.trip.startLocation;
    },
    tripEndLocation() {
      return this.$store.state.trip.endLocation;
    },
    routes() {
      return this.$store.state.trip.directions.routes.map(route => {
        let legSteps = [];
        route.legs.forEach(({ steps }) => (legSteps = [ ...legSteps, ...steps ]));
        route.legs[0].steps = legSteps;
        return route;
      });
    }
  }
}
</script>

<style>
#trip-info {
  position: absolute;
  top: 15px;
  left: 15px;
}

.trip-summary {
  background: #fff;
  padding: 1rem;
  border-radius: 6px;
  width: 600px;
  margin: 5px 0;
}

@media (max-width: 600px) {
  #trip-info {
    top: 0;
    left: 0;
    margin: 15px;
  }

  #trip-step {
    top: 0!important;
    left: 0!important;
    padding: 1rem;
  }

  .trip-summary {
    width: 100%;
  }

  .trip-route h2 {
    font-size: 20px;
  }
}

</style>
